import React from 'react';

export default function TimeMessageLogo(props: React.HTMLAttributes<HTMLSpanElement>) {
    return (
        <span {...props}>
            <svg width='128' height='128' viewBox='0 0 128 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g clipPath='url(#clip0_10564_20225)'>
                    <rect width='128' height='128' rx='24.7742' fill='#DEE1E6'/>
                    <path d='M127.742 0H-0.15625V127.898H127.742V0Z' fill='#DEE1E6'/>
                    <path fillRule='evenodd' clipRule='evenodd' d='M46.8223 25.0512C40.2817 25.0689 34.5886 29.505 33.0033 35.8192L27.5192 57.6624C27.4826 57.8081 27.4051 57.9402 27.2957 58.0439L11.9428 72.7498C10.656 73.8767 11.4339 76.1348 13.3682 76.1344C32.8771 75.9783 51.1236 75.8941 70.6332 75.8412C77.174 75.8235 82.8667 71.3873 84.4523 65.0731L93.9639 27.188C94.2525 26.038 93.3768 24.9248 92.1856 24.928L46.8223 25.0512Z' fill='#333333'/>
                    <path fillRule='evenodd' clipRule='evenodd' d='M93.9309 50.6257H103.164C104.356 50.6257 105.23 51.7413 104.938 52.8904L97.1714 83.4564C97.1012 83.7318 97.1854 84.0234 97.3919 84.2199L111.87 97.9964C113.397 99.0848 112.925 101.62 110.446 101.608C99.7128 101.557 92.1955 101.48 81.4625 101.48H52.0782C41.9881 101.48 35.2761 90.8036 39.1598 81.6314C49.8481 81.5513 59.8466 81.5311 70.5354 81.5022C80.1829 80.9716 87.1159 76.0952 89.8816 66.7462L93.9309 50.6257Z' fill='#333333'/>
                </g>
                <defs>
                    <clipPath id='clip0_10564_20225'>
                        <rect width='128' height='128' rx='24.7742' fill='white'/>
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
